export const currentMedicationsData = {
  currentMedications: [
    {
      medicationName: 'Piperacillin and Tazobactam',
      brand_name: 'Piperacillin and Tazobactam',
      generic_name: 'Piperacillin and Tazobactam',
      dosage: {
        Type: 'INJECTION',
      },
      id: 3109,
      route: 'INTRAVENOUS',
      lastReviewed: '2022-04-19T13:49:29.056Z',
      startDate: '2022-04-19T13:49:21.146Z',
      endDate: null,
      note: 'additional note',
      frequency: {
        Unit: '1',
        Period: 'Twice a day',
        Timing: 'In the Evening',
      },
    },
    {
      medicationName: 'WELLBUTRIN XL',
      brand_name: 'WELLBUTRIN XL',
      generic_name: '',
      dosage: {
        Type: 'Tablet',
      },
      id: 3110,
      route: 'ORAL',
      lastReviewed: '2022-06-19T12:49:29.056Z',
      startDate: '2022-06-10T13:50:21.146Z',
      endDate: null,
      note: 'additional note',
      frequency: {
        Unit: '1',
        Period: 'Every day',
        Timing: 'In the Evening',
      },
    },
    {
      medicationName: 'NORETHINDRONE ACETATE',
      brand_name: '',
      generic_name: 'NORETHINDRONE ACETATE',
      dosage: {
        Type: 'Spray',
      },
      id: 3111,
      route: 'TOPICAL',
      lastReviewed: '2022-06-10T12:49:29.056Z',
      startDate: '2022-06-01T13:50:21.146Z',
      endDate: null,
      note: 'additional note',
      frequency: {
        Unit: '1',
        Period: '4 times a day',
        Timing: 'Before Meals',
      },
    },
    {
      medicationName: 'Dimethicone (Remedy Skin Repair)',
      brand_name: '',
      generic_name: 'Dimethicone',
      dosage: {
        Type: 'Cream',
      },
      id: 3112,
      route: 'TOPICAL',
      lastReviewed: '2022-09-20T12:49:29.056Z',
      startDate: null,
      endDate: null,
      note: 'additional note',
      frequency: {
        Unit: '1',
        Period: '3 times a day',
        Timing: 'As Directed',
      },
    },
  ],
  archivedMedications: [
    {
      medicationName: 'Frosted Mint',
      brand_name: 'Frosted Mint',
      generic_name: 'Frosted Mint',
      id: 3137,
      dosage: {
        Type: 'SPRAY',
      },
      route: 'TOPICAL',
      lastReviewed: '2022-02-20T11:15:00.905Z',
      startDate: '2022-02-11T11:05:28.958Z',
      endDate: '2022-04-20T11:15:13.664Z',
      note: 'hhhh',
      reasonForDiscontinuing: 'Adverse reaction',
    },
    {
      medicationName: 'Seven Three Hand Sanitizer',
      brand_name: 'Seven Three Hand Sanitizer',
      generic_name: 'Seven Three Hand Sanitizer',
      id: 3139,
      dosage: {
        Type: 'LIQUID',
      },
      route: 'TOPICAL',
      lastReviewed: '2022-04-19T11:44:51.407Z',
      startDate: '2022-04-05T11:30:27.472Z',
      endDate: '2022-04-19T11:44:55.734Z',
      note: null,
      reasonForDiscontinuing: 'End of course',
    },
  ],
};
